import axios from 'axios'
import _ from 'lodash'
import {
  getDomainWithPrefix,
  getGUID,
  getIp,
  getProtocol,
  isSnsLogin,
  logger,
  setDisableScrolling
} from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import store from '@/store'
import { SHOW_LOGIN_POPUP } from '@/common/resources/store.type.const'
import constant from '@/common/resources/constant'
import { stringify } from 'query-string'
import { DOMAIN_PLAYER } from '@/common/utils/request.const'
import { PLAYER_EVENT } from '@/common/utils/player.interface'
import { getLiveChannelsDetail, getMovieContentsDetail, getVodContentsDetail } from '@/common/utils/request'

/**
 * 플레이어 생성 관련 모듈 정의
 * TODO :: trailer, main이 동시에 존재하진 않으므로 현재는 하나의 instance (window.playerInstance) 변수 하나에 저장되고 갱신되나
 * 나중을 생각하면 구분되는게 좋을듯
 */

/**
 * 현재 도메인에 맞춰 플레이어 도메인 (dev-, qa- 붙은)
 */
export const PLAYER_ORIGIN = getDomainWithPrefix(`${getProtocol()}//${DOMAIN_PLAYER}`)
/**
 * 최신 버전을 관리하는 json url
 * @returns {`${*}/dist/scalableplayer.lastestversion.json?hash=${string}`}
 */
export const getLastestVersionJsonUrl = () => {
  return `${PLAYER_ORIGIN}/dist/scalableplayer.lastestversion.json?hash=${Date.now().toString()}`
}

/**
 * 플레이어 객체 생성시 인자로 전달되는 타입
 * @type {{INSTANT: string, APOLLO: string, MAIN: string, TRAILER: string, MOBILE: string}}
 */
export const PlayerType = {
  INSTANT: 'i',
  MAIN: 'm', // PC Web
  APOLLO: 'apollo', // 아폴로 앱
  MOBILE: 'mobile', // 아폴로 앱이 아닌 외부에서 아폴로 url을 치고 들어간 경우 (실제 쓰이진 않음, 다만 구분을 위해 추가)
  TRAILER: 'trailer' // 예고편 플레이어
}

/**
 * 플레이어 js, css 파일명에 들어가는 이름
 * @type {{TOTAL: string, SET_PC: string, APOLLO: string, INSTANT: string, MAIN: string, CCOS: string}}
 */
export const PLAYER_PACKAGE_TYPE = {
  SET_PC: 'set-pc',
  APOLLO: 'apollo',
  CCOS: 'ccos',
  INSTANT: 'instant',
  MAIN: 'main',
  TOTAL: 'total'
}

/**
 * 플레이어 생성 시 사용가능한 옵션들
 * @type {{IS_POPUP_WINDOW: string, BACK_PARAMS: string, BACK_ABSOLUTE_PATH: string, IS_FADEIN_EFFECT: string, IS_SEPARATE_UI: string}}
 */
export const PLAYER_OPTIONS = {
  IS_POPUP_WINDOW: 'isPopupWindow',
  IS_SEPARATE_UI: 'isSeparateUI',
  BACK_PARAMS: 'backParams',
  BACK_ABSOLUTE_PATH: 'backAbsolutePath',
  IS_FADEIN_EFFECT: 'isFadeInEffect'
}

export const showDownloadLayoutWithContext = (context) => () => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    context.downloadLayout = true
    setDisableScrolling(true)
  }
}

const setVoucherPopup = (type, contentInfo) => {
  const baseUrl = '/voucher/popup'
  const params = {}
  switch (type) {
    case 'vod':
    case 'voddownload':
      params.type = 'voucher'
      params.contenttype = 'vod'
      params.contentid = _.get(contentInfo, 'contentid', '')
      params.programid = _.get(contentInfo, 'programid', '')
      params.channelid = _.get(contentInfo, 'channelid', '')
      params.cpid = _.get(contentInfo, 'cpid', '')
      if (type === 'voddownload') {
        params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
      }
      break
    case 'movie':
    case 'moviedownload':
      params.type = 'movie'
      params.contenttype = 'movie'
      params.contentid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
      params.programid = _.get(contentInfo, 'movieid', '') || _.get(contentInfo, 'contentid', '')
      params.channelid = 'none'
      params.cpid = _.get(contentInfo, 'cpid', '')
      params.playy = _.indexOf(_.get(contentInfo, 'moviemarks', []), 'playy') > -1 ? 'y' : 'n'
      if (type === 'moviedownload') {
        params.downloadyn = _.get(contentInfo, 'downloadable', 'n')
      }
      break
    case 'live':
      params.type = 'voucher'
      params.contenttype = 'live'
      params.contentid = _.get(contentInfo, 'channelid', '')
      params.programid = _.get(contentInfo, 'programid', '')
      params.channelid = _.get(contentInfo, 'channelid', '')
      params.cpid = _.get(contentInfo, 'cpid', '')
      break
    case 'clip':
      params.type = 'all'
      break
  }
  voucherPopup = window.open(`${baseUrl}?${stringify(params)}`, '', 'width=700, height=780, scrollbars=yes')
  voucherPopup.focus()
  // if (voucherPopup) {
  //   voucherPopupInterval = setInterval(checkClosePopup, 800)
  // }
}
let voucherPopup = null
export const showVoucherPopup = (type, contentId, programId, channelId, cpid) => {
  if (cookie.hasNotCredential()) {
    store.commit(SHOW_LOGIN_POPUP)
  } else {
    if (isSnsLogin()) {
      if (!confirm(constant.MSG_VOUCHER_SNS_ALERT)) { return }
    }

    if (typeof type === 'string') {
      let callApi = getVodContentsDetail({ contentid: contentId })
      if (type === 'movie' || type === 'moviedownload') {
        callApi = getMovieContentsDetail({ movieid: contentId })
      } else if (type === 'live') {
        callApi = getLiveChannelsDetail({ channelid: channelId })
      }
      callApi.then(({ data }) => {
        setVoucherPopup(type, data)
      }).catch((err) => { console.log(err) })
    } else {
      setVoucherPopup(_.get(type, 'type', 'vod'), _.get(type, 'contentInfo', {}))
    }
  }
}

export const showVoucherPopupWithContext = ({ type, contentInfo }) => () => { showVoucherPopup({ type, contentInfo }) }

export const setPlayerModeDefault = () => {
  if (window.playerInstance) {
    window.playerInstance.setDefaultMode()
  }
}

const externalJSLoader = (src) => {
  const fragment = document.createDocumentFragment()
  const jsEl = document.createElement('script')
  jsEl.setAttribute('src', src)
  jsEl.async = true
  fragment.appendChild(jsEl)
  const existScriptTab = document.getElementsByTagName('script')[0]
  existScriptTab.parentNode.insertBefore(fragment, existScriptTab)
}

const externalCssLoader = (src) => {
  const fragment = document.createDocumentFragment()
  const linkEl = document.createElement('link')
  linkEl.setAttribute('rel', 'stylesheet')
  linkEl.setAttribute('type', 'text/css')
  linkEl.setAttribute('href', src)
  fragment.appendChild(linkEl)
  const existScriptTab = document.getElementsByTagName('script')[0]
  existScriptTab.parentNode.insertBefore(fragment, existScriptTab)
}

const loadScript = (packageType, data) => {
  return new Promise((resolve, reject) => {
    // Global Callback
    window.loadedScalablePlayer = function () {
      resolve(window.ScalablePlayer)
    }
    try {
      const versions = _.get(data, 'lastest_versions', '')

      if (versions === '' || !versions[packageType]) {
        throw new Error(`no versions packageType: ${packageType}`)
      }
      const scriptSrc = `${PLAYER_ORIGIN}/dist/${versions[packageType].script}`
      const styleSrc = `${PLAYER_ORIGIN}/dist/${versions[packageType].style}`
      externalJSLoader(scriptSrc)
      externalCssLoader(styleSrc)
    } catch (e) {
      // 실패 시 기존 통합 플레이어로 호출
      const version = _.get(data, 'lastest_version', '')
      const scriptSrc = `${PLAYER_ORIGIN}/dist/scalableplayer.${version}.js`
      const styleSrc = `${PLAYER_ORIGIN}/dist/scalableplayer.${version}.css`
      externalJSLoader(scriptSrc)
      externalCssLoader(styleSrc)
    }
  })
}
export function getPlayerClass (packageType) {
  if (window.ScalablePlayer) {
    console.log('exist!! return exist player class')
    return new Promise((resolve, reject) => {
      resolve(window.ScalablePlayer)
    })
  } else {
    console.log('not exist!! return new player class')
    return axios.get(getLastestVersionJsonUrl())
      .then(({ data }) => {
        return loadScript(packageType, data)
      })
  }
}

const getPlayerDelegateInstance = (context, callbacks) => {
  delete window.playerDelegate
  class PlayerDelegate {
    constructor (context) {
      this.context = context
      context = null
    }
    onEvent (e, ...value) {
      switch (e) {
        case PLAYER_EVENT.UPDATE:
          logger('cyan')('UPDATE')
          this.context.$events.$emit(PLAYER_EVENT.UPDATE, value[0])
          break
        case PLAYER_EVENT.PLAY:
          logger('cyan')('PLAY')
          this.context.$events.$emit(PLAYER_EVENT.PLAY, value[0])
          break
        case PLAYER_EVENT.END:
          logger('cyan')('END')
          this.context.$events.$emit(PLAYER_EVENT.END, value[0])
          break
        case PLAYER_EVENT.EXPIRED_CREDENTIAL:
          logger('cyan')('EXPIRED_CREDENTIAL')
          this.context.$events.$emit(PLAYER_EVENT.EXPIRED_CREDENTIAL, value[0])
          break
        case PLAYER_EVENT.SET_FULLSCREEN:
          logger('cyan')('SET_FULLSCREEN')
          this.context.$events.$emit(PLAYER_EVENT.SET_FULLSCREEN, value[0])
          break
        case PLAYER_EVENT.SHOW_TOAST:
          logger('cyan')('SHOW_TOAST')
          this.context.$events.$emit(PLAYER_EVENT.SHOW_TOAST, value[0])
          break
        case PLAYER_EVENT.MOVE_PAGE:
          logger('cyan')('MOVE_PAGE')
          this.context.$events.$emit(PLAYER_EVENT.MOVE_PAGE, value)
          break
        default:
          break
      }
    }
  }
  return new PlayerDelegate(context)
}

/**
 * 플레이어 객체 로드를 위한 시작 함수
 * @param context 플레이어를 로드한 컴포넌트
 * @param targetEl 플레이어 dom이 들어갈 부모 dom
 * @param type 플레이어 객체 생성시 들어갈 타입 PlayerType
 * @param packageType PLAYER_PACKAGE_TYPE 중 하나
 * @returns {Promise<void>}
 */
export async function playerDelegate (context, targetEl, type, packageType, options = {}) {
  window.playerInstance && window.playerInstance.destructor && window.playerInstance.destructor()
  window.playerInstance = null
  const playerDelegateInstance = getPlayerDelegateInstance(context)
  const PlayerClass = await getPlayerClass(packageType)
  window.playerInstance = new PlayerClass(targetEl, type, playerDelegateInstance, options)
  context.playerInit()
  context = null
}

export const showLoginPopup = () => {
  store.commit(SHOW_LOGIN_POPUP)
}

export const getNoneCredentialUserInfo = () => {
  return {
    credentialKey: 'none',
    GUID: getGUID(),
    clientIP: getIp(),
    userNo: 'none',
    userID: 'none',
    profileID: 'none',
    pooqzoneType: cookie.getPooqZoneType()
  }
}

/**
 * 플레이어 생성 시 옵션 지정 함수
 *     isPopupWindow: false, 팝업플레이어 여부
 *     isSeparateUI: false, 단독 페이지 플레이어 여부
 *     backParams: {}, 뒤로가기 버튼 클릭시 이동할 url params
 *     backAbsolutePath: null, 뒤로가기 버튼 클릭 시 이동 path
 *     isFadeInEffect: false  플레이어 진입 시 fade in 사용 여부
 * @param options
 */
export const getOptions = (options = {}) => {
  let defaultOptions = {}
  defaultOptions[PLAYER_OPTIONS.IS_POPUP_WINDOW] = false
  defaultOptions[PLAYER_OPTIONS.IS_FADEIN_EFFECT] = false
  defaultOptions[PLAYER_OPTIONS.BACK_ABSOLUTE_PATH] = null
  defaultOptions[PLAYER_OPTIONS.BACK_PARAMS] = {}
  defaultOptions[PLAYER_OPTIONS.IS_SEPARATE_UI] = true

  if (options) {
    defaultOptions = Object.assign(defaultOptions, options)
  }

  return defaultOptions
}
